const getUserCountryByIp = () => {
  const url = document.getElementById("adminUrl").innerHTML;

  const formData = new FormData();
  formData.append('action', 'getUserCountryByIp');
  return fetch(url, {
    method: "POST",
    credentials: "same-origin",
    body: formData,
  });

}

export { getUserCountryByIp };
